var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.survey && _vm.questions) ? _c('b-card', {
    staticClass: "p-0 m-0",
    attrs: {
      "header": _vm.survey.name
    }
  }, [_c('div', {
    staticClass: "spnod-admin__account--section"
  }, [(_vm.questions) ? _c('ul', _vm._l((_vm.questions), function(question) {
    return _c('li', {
      staticClass: "spnod-admin__form--list pb-2"
    }, [_c('b-row', {
      staticClass: "mx-0"
    }, [_vm._v(_vm._s(question.question))]), _vm._v(" "), _c('b-row', {
      staticClass: "mx-0"
    }, [_c('span', {
      staticClass: "text-muted"
    }, [_vm._v(_vm._s(question.answer ? question.answer : 'N/A'))])])], 1)
  }), 0) : _vm._e()]), _vm._v(" "), (!_vm.forClient) ? _c('b-button', {
    staticClass: "spnod-admin__form--button",
    attrs: {
      "size": "sm"
    },
    on: {
      "click": function($event) {
        return _vm.$emit('toggleSurvey')
      }
    }
  }, [_vm._v("Edit")]) : _vm._e()], 1) : _vm._e()
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5586caba","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/components/Surveys/SurveyList.vue
// module id = C0Nr
// module chunks = 2